
import React, { useState, useEffect } from 'react';
import { API_BASE_URL, INSERT_VARIANT } from '../../../Config';
import Axios from 'axios';
import Swal from 'sweetalert2';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddVariant = () => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    // const [formData, setFormData] = useState({
    //     Name: null,
    //     Value: null,
    //     Description: "",
    //     Isactive: 1,
    //     CreatedBy: userDataSession.UserId,
    //     Calc: ""
    // });

    const initialFormData = {
        Name: null,
        Value: null,
        Description: "",
        Isactive: 1,
        Calc: ""
      };
      
      const [formData, setFormData] = useState(initialFormData);
      
      const handleCancel = () => {
        setFormData(initialFormData); // Reset the form data
      };

    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        setSubmitBtnLoading(true);

        let updatedFormData = {
            ...formData,
            CreatedBy: userDataSession.UserId, // Assign CreatedBy dynamically
            Description: formData.Description === "" ? "NULL" : formData.Description,
            Calc: formData.Calc === "" ? "NULL" : formData.Calc
        };

        console.log(updatedFormData, 'sending to  api');

        Axios.post(`${API_BASE_URL}${INSERT_VARIANT}`, updatedFormData)
            .then(response => {
                console.log(response.data);

                if (response.data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);

                    // Show success message
                    Swal.fire({
                        title: `Variant added Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        // Reload the page after the user acknowledges the success message
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);

                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })

            .catch(error => {
                setSubmitBtnLoading(false);
                // Handle error
                console.error('Error adding category:', error);
            });
    };

    return (
        <>
            {/* Add Unit */}
            {submitBtnLoading&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightVTAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '30%', maxWidth: '30%' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Create Variant</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="Name"
                                placeholder='Enter variant name'
                                value={formData.Name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="input-blocks">
                            <label className="form-label">Value</label>
                            <input
                                type='text'
                                className='form-control'
                                name="Value"
                                value={formData.Value}
                                onChange={handleChange}
                                placeholder='Enter value'
                                maxLength={10}
                                required
                            />
                        </div>
                        <div className="mb-0">
                            <span className="form-label">Calculation</span>
                            <input
                                type="number"
                                className="form-control"
                                name="Calc"
                                placeholder='Enetr calculation'
                                value={formData.Calc}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="input-blocks">
                            <label className="form-label">Description</label>
                            <textarea
                                type='text'
                                className='form-control'
                                name="Description"
                                value={formData.Description}
                                onChange={handleChange}
                                placeholder='Enter description'
                            ></textarea>
                        </div>
                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={handleCancel}
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button to="#" className="btn btn-submit"
                             disabled={submitBtnLoading}>
                                {submitBtnLoading ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/* /Add Unit */}
        </>

    )
}

export default AddVariant
